<template>
	<v-dialog v-model="showDialog" width="500" min-height="400" persistent>
		<v-card>
			<v-overlay :absolute="true" :value="loading"></v-overlay>
			<v-card-title> Reference List Value </v-card-title>
			<v-card-text>
				<v-text-field
					ref="Id"
					class="d-none"
					label="Id"
					v-model="id"
					:rules="[rules.required]"
					hide-details="auto"
				></v-text-field>
				<v-text-field
					ref="TypeId"
					class="d-none"
					label="TypeId"
					v-model="typeId"
					:rules="[rules.required]"
					hide-details="auto"
				></v-text-field>
				<v-text-field
					ref="TypeName"
					class="d-none"
					label="TypeName"
					v-model="typeName"
					:rules="[rules.required]"
					hide-details="auto"
				></v-text-field>
				<v-text-field
					ref="Value"
					label="Value"
					v-model="value"
					:rules="[rules.required]"
					hide-details="auto"
					@keydown.enter="onSave"
					autofocus
				></v-text-field>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-btn @click.stop="onSave" color="primary">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { ReferenceListsActions } from '../../../store/actions';
export default {
	name: 'ReferenceListValueDialog',
	props: {
		showDialog: Boolean,
		action: String,
		item: Object,
		type: Object,
	},
	computed: {
		insertForm() {
			return {
				Value: this.value,
				TypeId: this.type.Id,
				TypeName: this.type.Name,
			};
		},

		form() {
			return {
				Id: this.id,
				TypeId: this.type.Id,
				Value: this.value,
				TypeName: this.type.Name,
			};
		},
	},
	data() {
		return {
			loading: false,
			id: null,
			typeId: null,
			typeName: '',
			value: '',
			rules: {
				required: (value) => !!value || 'Field is required',
			},
		};
	},
	mounted() {
		if (this.item) {
			this.id = this.item.Id;
			this.typeId = this.item.TypeId;
			this.value = this.item.Value;
			this.typeName = this.item.Name;
		} else {
			this.typeId = this.type.Id;
			this.typeName = this.type.Name;
		}
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
		onSave() {
			let storeAction = null;
			let form = null;
			if (this.action === 'add') {
				storeAction = ReferenceListsActions.ADD_REFERENCE_LIST_VALUE;
				form = this.insertForm;
			}

			if (this.action === 'edit') {
				storeAction = ReferenceListsActions.UPDATE_REFERENCE_LIST_VALUE;
				form = this.form;
			}
			if (!form) return;
			if (!this.validateForm(form)) return;
			this.loading = true;
			this.$store
				.dispatch(storeAction, form)
				.then(() => {
					this.loading = false;
					this.$emit('close');
				})
				.catch(() => {
					this.loading = false;
				});
		},
		validateForm(form) {
			let formHasErrors = false;
			Object.keys(form).forEach((f) => {
				if (!form[f]) formHasErrors = true;
				this.$refs[f].validate(true);
			});
			return !formHasErrors;
		},
	},
};
</script>
